// extracted by mini-css-extract-plugin
export default {"bottomInputContainer":"styles_bottomInputContainer__sYHAy","checkbox":"styles_checkbox__NjIz5","active":"styles_active__NfwTt","label":"styles_label__iMfDc"};